import { Component, input, output } from '@angular/core';
import { Motive, SubMotive } from '../../evaluation.model';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-motive-editor',
  imports: [MatIconModule, TranslateModule],
  templateUrl: './motive-editor.component.html',
  styleUrl: './motive-editor.component.scss',
})
export class MotiveEditorComponent {
  motives = input.required<Motive[]>();
  type = input.required<'negative' | 'positive'>();

  motiveUpdate = output<{
    type: 'negative' | 'positive';
    motiveId: string;
    updates: Partial<Motive>;
  }>();
  motiveAdd = output<{ type: 'negative' | 'positive'; motive: Motive }>();
  motiveDelete = output<{ type: 'negative' | 'positive'; motiveId: string }>();
  subMotiveAdd = output<{ type: 'negative' | 'positive'; motiveId: string; subMotive: Motive }>();
  subMotiveUpdate = output<{
    type: 'negative' | 'positive';
    motiveId: string;
    subMotiveId: string;
    updates: Partial<Motive>;
  }>();
  subMotiveDelete = output<{
    type: 'negative' | 'positive';
    motiveId: string;
    subMotiveId: string;
  }>();

  onMotiveFieldChange(motiveId: string, field: keyof Motive, value: string): void {
    this.motiveUpdate.emit({
      type: this.type(),
      motiveId,
      updates: { [field]: value },
    });
  }

  onDeleteMotive(motiveId: string): void {
    this.motiveDelete.emit({ type: this.type(), motiveId });
  }

  onAddMotive(): void {
    const newMotive: Motive = {
      id: `NEW${Date.now()}`,
      title: '',
      title_key_SF: '',
      checked: false,
      subMotives: [],
    };
    this.motiveAdd.emit({ type: this.type(), motive: newMotive });
  }

  onAddSubMotive(motiveId: string): void {
    const newSubMotive: Motive = {
      id: `${motiveId}${Date.now()}`,
      title: '',
      title_key_SF: '',
      checked: false,
    };
    this.subMotiveAdd.emit({ type: this.type(), motiveId, subMotive: newSubMotive });
  }

  onSubMotiveFieldChange(
    motiveId: string,
    subMotiveId: string,
    field: keyof Motive,
    value: string
  ): void {
    this.subMotiveUpdate.emit({
      type: this.type(),
      motiveId,
      subMotiveId,
      updates: { [field]: value },
    });
  }

  onDeleteSubMotive(motiveId: string, subMotiveId: string): void {
    this.subMotiveDelete.emit({ type: this.type(), motiveId, subMotiveId });
  }
}
